import { Injectable } from '@angular/core';
import * as CryptoJS from 'crypto-js';

@Injectable({
  providedIn: 'root'
})
export class AESEncryptDecryptService {

  private secretKey = 'm9JUkAeJfYx3jWXhn7eWj7j6PmEyzMqQAHrPwbc4GcPY3ZDv3R6ZRprNtxL'; // '54acb888-bbaf-494a-9d0d-306b4e0ad90c';
  constructor() { }

  encrypt(value: string): string {
    // return CryptoJS.AES.encrypt(value, this.secretKey.trim()).toString();
    return CryptoJS.AES.encrypt(JSON.stringify(value), this.secretKey).toString();

  }

  decrypt(textToDecrypt: string) {
    // return CryptoJS.AES.decrypt(textToDecrypt, this.secretKey.trim()).toString(CryptoJS.enc.Utf8);
    const bytes = CryptoJS.AES.decrypt(textToDecrypt, this.secretKey);
    const decryptedData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
    return decryptedData;
  }
}
